module.exports = __webpack_public_path__ + "static/media/plan-C5-mobile-en.93d435a4.png";